// extracted by css-extract-rspack-plugin
export default {"copper":"h_mdcK","name":"pXCUrJ"};